import { render } from "./elem.vue?vue&type=template&id=2421318e&scoped=true"
import script from "./elem.vue?vue&type=script&lang=js"
export * from "./elem.vue?vue&type=script&lang=js"

import "./elem.vue?vue&type=style&index=0&id=2421318e&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2421318e"]])

export default __exports__